import React from 'react';
import { IconButton, IconButtonProps, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import FavoriteDisabledFill from '@/public/icons/favorite_disabled_fill.svg';
import FavoriteDisabledLine from '@/public/icons/favorite_disabled_line.svg';
import FavoriteOnFill from '@/public/icons/favorite_on_fill.svg';
import FavoriteOnLine from '@/public/icons/favorite_on_line.svg';
import FavoriteOffLine from '@/public/icons/favorite_off_line.svg';
import FavoriteOffFill from '@/public/icons/favorite_off_fill.svg';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import FavoriteBlackOffLine from '@/public/icons/board/favorite-black-line-off.svg';
import FavoriteBlackOnLine from '@/public/icons/board/favorite-black-line-on.svg';

export type FavoriteButtonProps = {
  isFavorite: boolean;
  isLoading?: boolean;
  theme?: 'default' | 'black';
  sx?: SxProps<Theme>;
} & IconButtonProps;

const FavoriteButton = ({
  isFavorite,
  disabled,
  isLoading,
  theme = 'default',
  sx,
  ...buttonProps
}: FavoriteButtonProps) => {
  const isBlackTheme = theme === 'black';
  return (
    <IconButton
      {...buttonProps}
      disableRipple
      disabled={disabled}
      sx={{
        padding: 0,
        borderRadius: '2px',
        '&:not(:disabled):hover': { background: 'var(--dk-bg-subtle, #F9FAFB)' },

        svg: { display: 'block', width: '20px', height: '20px' },

        '.icon-default': { display: 'block' },
        '.icon-pressed': { display: 'none' },
        '.icon-disabled': { display: 'none' },

        '&:active .icon-default': { display: 'none' },
        '&:active .icon-pressed': { display: 'block' },

        '&:disabled .icon-default': { display: 'none' },
        '&:disabled .icon-pressed': { display: 'none' },
        '&:disabled .icon-disabled': { display: 'block' },
        ...sx,
      }}
    >
      {isLoading ? (
        <Spinner size="10px" theme="black" />
      ) : (
        <>
          {isFavorite ? (
            <>
              {isBlackTheme ? (
                <FavoriteBlackOnLine className="icon-default" />
              ) : (
                <>
                  <FavoriteOnFill className="icon-default" />
                  <FavoriteOnLine className="icon-pressed" />
                  <FavoriteDisabledFill className="icon-disabled" />
                </>
              )}
            </>
          ) : (
            <>
              {isBlackTheme ? (
                <FavoriteBlackOffLine />
              ) : (
                <>
                  <FavoriteOffLine className="icon-default" />
                  <FavoriteOffFill className="icon-pressed" />
                  <FavoriteDisabledLine className="icon-disabled" />
                </>
              )}
            </>
          )}
        </>
      )}
    </IconButton>
  );
};

export default FavoriteButton;
